'use strict';

/**
 * @function
 * @description Extracts all parameters from a given query string into an object
 * @param {String} qs The query string from which the parameters will be extracted
 */
const getQueryStringParams = (qs) => {
    if (!qs || qs.length === 0) { return {}; }
    const params = {},
        unescapedQS = decodeURIComponent(qs);
    // Use the String::replace method to iterate over each
    // name-value pair in the string.
    unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
        function ($0, $1, $2, $3) {
            params[$1] = $3;
        }
    );
    return params;
};

module.exports = getQueryStringParams;
